export default __webpack_public_path__ + "static/O0104-eeb422e72112133d37a92c068ddc51c8.png";